import React from 'react'
import GallerySlider from '../../Component/slider/gallery-slider'
import Layout from '../../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import layoutBgImg from '../../Images/layout/news.jpg'

const ImageSlider = () => {
    const {t} = useTranslation()
    return (
        <div className='mb-20'>
            <Layout
                title={t('news')}
                page={t('photomaterials')}
                layoutBgImg={layoutBgImg}
            />
            <div className='mt-6 px-4 xxl:px-12 xxxl:px-32 
                    xxxxl:px-64 xxxxxl:px-[400px] xxxxxxl:px-[650px] 
                    xxxxxxxl:px-[1600px] xxxxxxxxl:px-[2400px]'>
                <div className='h-[350px] md:h-[550px] xl:h-[750px] flex justify-center relative'>
                    <GallerySlider />
                </div>
            </div>
        </div>
    )
}

export default ImageSlider